import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import {
  TableBuilderFactory,
  TableComponent,
  TableConfig,
  TableDataPayload,
  TableLazyLoad,
} from '@web/shared/ui';
import {
  PublicBoxQuestionnaireCollectionFilter,
  PublicBoxQuestionnaireCollectionItem,
  PublicBoxQuestionnaireDataSourceService,
} from '@web/shared/module/shop';
import { PublicBoxQuestionnaireListCustomCellTemplateComponent } from '../../components/public-box-questionnaire-list-custom-cell-template/public-box-questionnaire-list-custom-cell-template.component';

@Component({
  selector: 'app-public-box-questionnaire-list',
  imports: [
    TableComponent,
    PublicBoxQuestionnaireListCustomCellTemplateComponent,
  ],
  templateUrl: './public-box-questionnaire-list.component.html',
  styleUrl: './public-box-questionnaire-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxQuestionnaireListComponent implements OnInit {
  /* prettier-ignore */
  private readonly builder = inject(TableBuilderFactory<PublicBoxQuestionnaireCollectionItem, PublicBoxQuestionnaireCollectionFilter>).create();
  /* prettier-ignore */
  private readonly boxQuestionnaireDataSource = inject(PublicBoxQuestionnaireDataSourceService);

  protected config!: TableConfig<
    PublicBoxQuestionnaireCollectionItem,
    PublicBoxQuestionnaireCollectionFilter
  >;

  public ngOnInit(): void {
    this.buildTable();
  }

  private buildTable(): void {
    this.config = this.builder
      .dataKey('id')
      .topScrollEnabled(false)
      .responsiveLayout('stack')
      .filtering(false)
      .columns((builder) => [
        builder
          .initCustom('logoUrl')
          .width('6rem')
          .label('Miniatura')
          .build(),

        builder
          .initCustom('name')
          .width('14rem')
          .label('Nazwa')
          .sortKey('name')
          .build(),

        builder
          .initCustom('orderNumber')
          .width('12rem')
          .label('Zamówienie')
          .sortKey('orderNumber')
          .build(),

        builder
          .initCustom('status')
          .width('10rem')
          .label('Status')
          .sortKey('status')
          .build(),

        builder
          .initDate('createdAt')
          .width('10rem')
          .label('Data dodania')
          .sortKey('createdAt')
          .build(),
      ])
      .dataSource({
        fetch: (
          lazyLoad: TableLazyLoad<PublicBoxQuestionnaireCollectionFilter>,
        ): Observable<TableDataPayload<PublicBoxQuestionnaireCollectionItem>> =>
          this.boxQuestionnaireDataSource.fetchCollection(lazyLoad),
      })
      .build();
  }
}
